import { marketNames } from "../../consts";
import { setFWUCampaignDetails, setFWUCampaigns } from "../../state/ducks";
import { dispatch, getState } from "../../state/store";
import httpClient from "../httpClient";
import { selectUserMarkets } from "../../state/selectors";
import { appUserService } from "../index";

const apiUrl = process.env.REACT_APP_MERCURY_API_URL;

const getRequestData = (endpoint) => {
  const url = `${apiUrl}/${endpoint}`;

  return url;
};

const fetchFWUCampaigns = async (markets) => {
  const userMarkets = selectUserMarkets()(getState());
  const baseUrl = getRequestData("getFirmwareCampaigns");
  // TODO: temp
  let url = `${baseUrl}?status=ACTIVE`;

  const marketQuery =
    !markets || markets.length == 0
      ? appUserService.isAdmin()
        ? null
        : userMarkets?.filter((m) => m !== marketNames.allMarkets)?.join(",")
      : markets.join(",");

  if (marketQuery) {
    url += `&markets=${marketQuery}`;
  }

  const result = await httpClient.get(url);

  if (result?.data) {
    dispatch(setFWUCampaigns(result.data));
  }

  return result;
};

const fetchFWUCampaignDetails = async (campaignName) => {
  const url = getRequestData(`getFirmwareCampaignDetails?campaign_name=${campaignName}`);

  const result = await httpClient.get(url);

  if (result?.data) {
    dispatch(setFWUCampaignDetails(result.data));
  }

  return result;
};

const createFWUCampaign = async (fwuCampaign) => {
  const url = getRequestData("otaUpdate/campaign");

  return await httpClient.post(url, { data: fwuCampaign });
};

const updateFWUCampaign = async (fwuCampaign) => {
  const url = getRequestData("otaUpdate/campaign");

  return await httpClient.put(url, { data: fwuCampaign });
};

const deactivateFWUCampaign = async (campaignName) => {
  const url = getRequestData(`/otaUpdate/campaign?campaign_name=${campaignName}`);

  return await httpClient.remove(url);
};

const fwuCampaignsService = {
  fetchFWUCampaigns,
  fetchFWUCampaignDetails,
  createFWUCampaign,
  updateFWUCampaign,
  deactivateFWUCampaign
};

export default fwuCampaignsService;
